module.exports = __webpack_public_path__ + "static/media/icon-moduleA2.f6c5cd6d.png";